import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axiosConn from "config/axiosConn";
import { useDispatch } from "react-redux";
import { userLoggedIn } from "../redux/auth/authSlice";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import HomePage from "./HomePage";
import CryptoJS from "crypto-js";

const secretKey = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";
const decryptUser = (encryptedUser) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedUser, secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Failed to decrypt user", error);
    return null;
  }
};

function FacultyPasswordUpdate() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);

  const activationToken = location.state?.activationToken;

  const handleClose = () => {
    setShow(false);
    navigate("/");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      toast.error("Please fill in all fields");
      return;
    }

    if (password.length < 8) {
      toast.error("Password must be at least 8 characters long");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      const response = await axiosConn("post", "/update-faculty-password", {
        password,
        activation_token: activationToken,
      });

      if (response.data.success) {
        // Automatically login the user after password creation
        if (response.data.user && response.data.accessToken) {
          const decryptedUser = decryptUser(response.data.user);
          if (decryptedUser) {
            dispatch(userLoggedIn({
              accessToken: response.data.accessToken,
              user: decryptedUser,
              lang: decryptedUser.lang || 'en-IN'
            }));

            localStorage.setItem("isLogin", true);
            toast.success("Password created successfully! Logging you in...");

            // Redirect to faculty dashboard
            navigate("/faculty", { replace: true });
          } else {
            toast.error("Failed to authenticate user data.");
            navigate("/", { replace: true });
          }
        } else {
          // Fallback to home page if user data not received
          toast.success("Password created successfully! Please login with your new password.");
          navigate("/", { replace: true });
        }
      } else {
        toast.error(response.data.message || "Failed to create password");
      }
    } catch (error) {
      console.error("Password update error:", error);
      toast.error(
        error.response?.data?.message || "An error occurred while creating password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div style={{ position: "relative" }}>
        <HomePage />
        
        <Modal
          show={show}
          onHide={handleClose}
          centered
          backdrop="static"
          keyboard={false}
          className="loginmodal"
        >
          <Modal.Body>
            <div className="popup-login-signup">
              <div className="login-box">
                <button
                  type="button"
                  className="popup-close-btn"
                  onClick={handleClose}
                >
                  X
                </button>
                <h2 className="text-center mb-4 fw-bold">Create Your Password</h2>
                <p className="text-center text-muted mb-4">
                  Set a strong password for your faculty account
                </p>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label fw-semibold">
                      New Password
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter password (min 8 characters)"
                        style={{ paddingRight: '40px' }}
                        required
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: 'absolute',
                          right: '12px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          zIndex: 10,
                          color: '#6c757d',
                          fontSize: '18px'
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>

                  <div className="mb-4">
                    <label htmlFor="confirmPassword" className="form-label fw-semibold">
                      Confirm Password
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Re-enter password"
                        style={{ paddingRight: '40px' }}
                        required
                      />
                      <span
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        style={{
                          position: 'absolute',
                          right: '12px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          zIndex: 10,
                          color: '#6c757d',
                          fontSize: '18px'
                        }}
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary w-100 py-2 fw-semibold"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Creating Password...
                      </>
                    ) : (
                      "Create Password"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      <Footer />
    </>
  );
}

export default FacultyPasswordUpdate;
